<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><img alt="" src="OEBPS/images/i.png"/></p>
<p class="pagebreak"> </p>
<p class="center"><img alt="" src="OEBPS/images/iii.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp1.vue?02d0df32